exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".wl-comments-container[data-v-1f97720a] {\n  height: 1.875rem;\n  margin-top: 0.0625rem;\n}\n.wl-title[data-v-1f97720a] {\n  font-weight: 700;\n  font-style: normal;\n  font-size: 0.083333rem;\n  color: #696969;\n  text-align: left;\n  line-height: 0.208333rem;\n}", ""]);

// exports
